<section class="seller-container">
  <form [formGroup]="formStepOne" autocomplete="off">
    <section class="ids-pt-8">
      <h2 class="ids-text-title-01">dados pessoais</h2>
      <section class="ids-row ids-pt-8">
        <ids-form-field
          class="ids-col-6"
          label="nome completo"
          [errorMessage]="getTextFieldError('name', 'o nome completo')"
        >
          <input idsInput formControlName="name"/>
          <ids-icon variant="primary">editar_outline</ids-icon>
        </ids-form-field>

        <ids-form-field class="ids-col-6" label="CPF" [errorMessage]="getErrorInvalid('CPF')">
          <input idsInput idsMask="999.999.999-99" formControlName="documentNumber" type="numeric"/>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="data de nascimento"
           [errorMessage]="getBirthDateFieldError('birth_date', 'a data de nascimento')"
        >
          <input
            idsDatepicker
            formControlName="birth_date"
          />
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="nacionalidade"
          [errorMessage]="getForgotFill('a nacionalidade')"
        >
          <ids-select formControlName="birth_nationality" required>
            <ids-option
              *ngFor="let option of listNacionalites"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="UF de nascimento"
          [errorMessage]="getForgotFill('a UF de nascimento')"
        >
          <ids-select formControlName="birth_state">
            <ids-option *ngFor="let option of listStates" [value]="option.uf">
              {{ option.uf }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ng-container
          *ngIf="formStepOne.get('birth_nationality')?.value.toLocaleLowerCase() === 'brasileira';else elseCity">
          <ids-shimmer class="ids-col-6" [show]="loadingCities">
            <ids-form-field
              *ngIf="!loadingCities"
              label="cidade de nascimento"
              [errorMessage]="getForgotFill('a cidade de nascimento')">
              <ids-select formControlName="birth_city">
                <ids-option *ngFor="let option of listCities" [value]="option.name">
                  {{ option.name }}
                </ids-option>
              </ids-select>
            </ids-form-field>
          </ids-shimmer>
        </ng-container>

        <ng-template #elseCity>
          <ids-form-field
            class="ids-col-6"
            label="cidade de nascimento"
            [errorMessage]="getForgotFill('a cidade de nascimento')"
          >
            <input idsInput formControlName="birth_city"/>
          </ids-form-field>
        </ng-template>

        <ids-form-field class="ids-col-6" label="gênero" [errorMessage]="getForgotFill('o gênero')">
          <ids-select formControlName="gender" required>
            <ids-option
              *ngFor="let option of listaSexo"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <app-domain-input-select
          class="ids-col-6"
          label="profissão ou principal ocupação"
          [errorMessage]="getForgotFill('a profissão ou principal ocupação')"
          [formParent]="formStepOne"
          formControlName="profession"
          (formParentChange)="formStepOne = $event"
          ngDefaultControl
        >
        </app-domain-input-select>

        <ids-form-field
          class="ids-col-6"
          label="estado civil"
          [errorMessage]="getForgotFill('o estado civil')"
        >
          <ids-select formControlName="relationship_maritalStatus" required>
            <ids-option
              *ngFor="let option of listaEstadoCivil"
              [value]="option.optValue"
              (click)="civiStateChange(option.optValue)"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="regime de bens"
          *ngIf="isMarried"
          [errorMessage]="getForgotFill('o regime de bens')"
        >
          <ids-select formControlName="relationship_propertyRegime" required>
            <ids-option
              *ngFor="let option of listaRegimeBens"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="data de casamento"
          *ngIf="isMarried"
          [errorMessage]="getDateFieldError('relationship_marriageDate', 'a data de casamento')"
        >
          <input
            idsDatepicker
            formControlName="relationship_marriageDate"
          />

        </ids-form-field>

        <section class="ids-col-6" *ngIf="isMarried">
          <p class="ids-form ids-pb-2 ids-form-selection-legend ids-col-6">
            cônjuge ou companheiro vai receber alguma parte na venda do imóvel?
          </p>
          <ids-form-selection-group inline>
            <ids-form-selection>
              <input
                type="radio"
                [value]="true"
                name="relationship_hasPartInSale"
                formControlName="relationship_hasPartInSale"
                idsRadioButton
              />
              <label>sim, vai receber</label>
            </ids-form-selection>
            <ids-form-selection>
              <input
                type="radio"
                [value]="false"
                name="relationship_hasPartInSale"
                formControlName="relationship_hasPartInSale"
                idsRadioButton
              />
              <label>não vai receber</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>

        <section class="ids-col-6" *ngIf="isSingle" style="width: 100%">
          <p class="ids-form ids-pb-2" style="width: 100%">convive em união estável?</p>
          <ids-form-selection-group inline>
            <ids-form-selection>
              <input
                type="radio"
                [value]="true"
                name="relationship_hasStableUnion"
                (click)="stableUnionChange(true)"
                formControlName="relationship_hasStableUnion"
                idsRadioButton
              />
              <label>sim</label>
            </ids-form-selection>
            <ids-form-selection>
              <input
                type="radio"
                [value]="false"
                name="relationship_hasStableUnion"
                (click)="stableUnionChange(false)"
                formControlName="relationship_hasStableUnion"
                idsRadioButton
              />
              <label>não</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>

        <ids-form-field
          class="ids-col-6"
          label="regime de bens"
          *ngIf="isSpouseParticipates"
          [errorMessage]="getForgotFill('o regime de bens')"
        >
          <ids-select formControlName="relationship_propertyRegime">
            <ids-option
              *ngFor="let option of listaRegimeBens"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="data da união"
          *ngIf="isSpouseParticipates"
          [errorMessage]="getDateFieldError('relationship_marriageDate', 'a data da união')"
        >
          <input
            idsDatepicker
            formControlName="relationship_marriageDate"
          />

        </ids-form-field>

        <section class="ids-col-6" *ngIf="isSpouseParticipates">
          <p class="ids-form ids-pt-2 ids-pv-4">
            Conjugue ou companheiro vai receber alguma parte na venda do imóvel?
          </p>
          <ids-form-selection-group inline>
            <ids-form-selection>
              <input
                type="radio"
                [value]="true"
                name="relationship_hasPartInSale"
                formControlName="relationship_hasPartInSale"
                idsRadioButton
              />
              <label>Sim, irá receber</label>
            </ids-form-selection>
            <ids-form-selection>
              <input
                type="radio"
                [value]="false"
                name="relationship_hasPartInSale"
                formControlName="relationship_hasPartInSale"
                idsRadioButton
              />
              <label>Não vai receber</label>
            </ids-form-selection>
          </ids-form-selection-group>
        </section>
      </section>
    </section>

    <section class="ids-pt-10">
      <h3 class="ids-text-section-02">documento de identificação</h3>

      <section class="ids-row">
        <ids-form-field
          class="ids-col-6"
          label="tipo de documento"
          [errorMessage]="getForgotFill('0 tipo de documento')"
        >
          <ids-select formControlName="document_type" required>
            <ids-option
              *ngFor="let option of listaDocumentos"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="número do documento"
          [errorMessage]="getErrorInvalid('número do documento')"
        >
          <input
            idsInput
            type="text"
            [minlength]="docNumMinLen"
            [maxlength]="docNumMaxLen"
            formControlName="document_number"
          />
        </ids-form-field>
        <ids-form-field
          class="ids-col-6"
          label="data de expedição"
          [errorMessage]="getDateFieldError('document_issueDate', 'a data de expedição')"
        >
          <input
            idsDatepicker
            formControlName="document_issueDate"
          />
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="órgao expedidor"
          [errorMessage]="getForgotFill('o órgão expedidor')"
        >
          <ids-select formControlName="document_issuingAuthority" required>
            <ids-option
              *ngFor="let option of listaOrgaoExpedidor"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>

        <ids-form-field class="ids-col-6" label="UF" [errorMessage]="getForgotFill('a UF')">
          <ids-select formControlName="document_issuingAuthorityState" required>
            <ids-option *ngFor="let option of listStates" [value]="option.uf">
              {{ option.uf }}
            </ids-option>
          </ids-select>
        </ids-form-field>
      </section>
    </section>

    <section class="ids-pt-10">
      <h3 class="ids-text-section-02">filiação</h3>

      <section class="ids-row">
        <ids-form-field
          class="ids-col-6"
          label="Nome completo da mãe"
          [errorMessage]="getTextFieldError('parentage_motherName', 'o nome completo da mãe')"
        >
          <input idsInput formControlName="parentage_motherName" required/>
        </ids-form-field>
        <ids-form-field
          class="ids-col-6"
          label="Nome completo do pai (opcional)"
          [errorMessage]="getTextFieldError('parentage_fatherName','o nome completo do pai')"
        >
          <input idsInput formControlName="parentage_fatherName"/>
        </ids-form-field>
      </section>
    </section>

    <section class="ids-pt-10">
      <h3 class="ids-text-section-02">contato</h3>

      <section class="ids-row">
        <ids-form-field class="ids-col-6" label="e-mail" [errorMessage]="getEmailFieldError('contact_email', 'o e-mail')">
          <input (blur)="normalizeEmail('contact_email')" type="email" idsInput formControlName="contact_email" required/>
        </ids-form-field>

        <ids-form-field
          class="ids-col-6"
          label="Celular ou telefone"
          [errorMessage]="getTextFieldError('contact_phone','o celular ou telefone')"
        >
          <input
            idsInput
            [idsMask]="phoneMask"
            formControlName="contact_phone"
            type="numeric"
            required
          />
        </ids-form-field>
      </section>
    </section>

    <section class="ids-pt-10">
      <app-cep-search
        [formParent]="formStepOne"
        [formControlNames]="[
          'address_zipCode',
          'address_state',
          'address_city',
          'address_district',
          'address_street',
          'address_number',
          'address_complement'
        ]"
        title="endereço residencial"
        ngDefaultControl
        (formParentChange)="formStepOne = $event"
      >
      </app-cep-search>
    </section>

    <section class="ids-pt-10 ids-row">
      <h3 class="ids-text-section-02 ids-col-12">local de entrega de correspondência</h3>
      <section class="ids-col-12">
        <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">onde deseja receber correspondências?</p>
        <ids-form-selection-group inline>
          <ids-form-selection>
            <input
              type="radio"
              [value]="true"
              name="deliveryAddress_isLocale"
              (click)="postLocationChange(true)"
              formControlName="deliveryAddress_isLocale"
              idsRadioButton
            />
            <label>residência</label>
          </ids-form-selection>
          <ids-form-selection>
            <input
              type="radio"
              [value]="false"
              name="deliveryAddress_isLocale"
              (click)="postLocationChange(false)"
              formControlName="deliveryAddress_isLocale"
              idsRadioButton
            />
            <label>outro endereço</label>
          </ids-form-selection>
        </ids-form-selection-group>
      </section>
    </section>

    <section class="ids-pt-10" *ngIf="isOtherLocation()">
      <app-cep-search
        [formParent]="formStepOne"
        [formControlNames]="[
          'deliveryAddress_zipCode',
          'deliveryAddress_state',
          'deliveryAddress_city',
          'deliveryAddress_district',
          'deliveryAddress_street',
          'deliveryAddress_number',
          'deliveryAddress_complement'
        ]"
        title=""
        ngDefaultControl
        (formParentChange)="formStepOne = $event"
      >
      </app-cep-search>
    </section>

    <section class="ids-pt-10 ids-row">
      <section class="ids-col-12">
        <article class="seller-tooltip">
          <h3 class="ids-text-section-02 ids-col-12">dados do procurador</h3>
        </article>
      </section>

      <section class="ids-col-12">
        <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">
          o vendedor será representado por uma procuração?
        </p>
        <ids-form-selection-group inline>
          <ids-form-selection>
            <input
              type="radio"
              [value]="true"
              name="attorneyData_useAttorney"
              (click)="procuratorChange(true)"
              formControlName="attorneyData_useAttorney"
              idsRadioButton
            />
            <label>sim, será representado</label>
          </ids-form-selection>
          <ids-form-selection>
            <input
              type="radio"
              [value]="false"
              name="attorneyData_useAttorney"
              (click)="procuratorChange(false)"
              formControlName="attorneyData_useAttorney"
              idsRadioButton
            />
            <label>não será representado</label>
          </ids-form-selection>
        </ids-form-selection-group>
      </section>

      <section class="ids-col-12" *ngIf="isProxyData">
        <div class="ids-row">
          <ids-form-field
            class="ids-col-6"
            label="nome completo procurador"
            [errorMessage]="getTextFieldError('attorneyData_fullName','o nome completo procurador')"
          >
            <input type="text" idsInput formControlName="attorneyData_fullName"/>
          </ids-form-field>
          <ids-form-field
            class="ids-col-6"
            label="CPF ou CNPJ"
            [errorMessage]="getErrorInvalid('CPF ou CNPJ')"
          >
            <input
              idsInput
              appUpperCaseInput
              [idsMask]="maskCpfCnpj"
              (change)="checkValidCpfCnpj()"
              formControlName="attorneyData_documentNumber"
            />
          </ids-form-field>
        </div>
        <div class="ids-row">
          <ids-form-field
            class="ids-col-6"
            label="e-mail"
            [errorMessage]="getEmailFieldError('attorneyData_email', 'o e-mail')"
          >
            <input idsInput (blur)="normalizeEmail('attorneyData_email')"  formControlName="attorneyData_email"/>
          </ids-form-field>
          <ids-form-field
            class="ids-col-6"
            label="Celular ou telefone"
            [errorMessage]="getTextFieldError('attorneyData_phone','o celular ou telefone')"
          >
            <input
              type="numeric"
              idsInput
              [idsMask]="phoneMask"
              formControlName="attorneyData_phone"
            />
          </ids-form-field>
        </div>
      </section>
    </section>

    <section class="ids-pt-10 ids-row">
      <h3 class="ids-text-section-02 ids-col-12">informações complementares</h3>
      <section class="ids-col-12">
        <p class="ids-form ids-pt-2 ids-pv-4 ids-col-12">
          como pessoa física, você é empregador, trabalhador autônomo ou produtor rural e mantém
          funcionários registrados a seu serviço?
        </p>
        <ids-form-selection-group class="ids-pt-4" inline>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="true"
              name="additionalInformation_hasEmployee"
              formControlName="additionalInformation_hasEmployee"
              idsRadioButton
            />
            <label>sim</label>
          </ids-form-selection>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="false"
              name="additionalInformation_hasEmployee"
              formControlName="additionalInformation_hasEmployee"
              idsRadioButton
            />

            <label>não</label>
          </ids-form-selection>
        </ids-form-selection-group>
      </section>
    </section>

    <section class="ids-pt-4 ids-row">
      <section class="ids-col-12">
        <p class="ids-form ids-pb-4 ids-col-12">
          A venda deste imóvel será para um dos seus herdeiros legais?
        </p>
        <ids-form-selection-group class="ids-pt-4" inline>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="true"
              name="additionalInformation_isSellingToFamily"
              formControlName="additionalInformation_isSellingToFamily"
              idsRadioButton
            />
            <label>sim</label>
          </ids-form-selection>

          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="false"
              name="additionalInformation_isSellingToFamily"
              formControlName="additionalInformation_isSellingToFamily"
              idsRadioButton
            />
            <label>não</label>
          </ids-form-selection>
        </ids-form-selection-group>
      </section>
    </section>

    <section class="ids-row ids-pt-4" style="width: 100%">
      <section class="ids-col-12" style="width: 100%">
        <p class="ids-col-12" style="width: 100%">
          Você é menor de 18 anos, interdito (quem não responde por seus atos legalmente) ou tem
          imóvel como parte de um espólio ainda não partilhado?
        </p>
        <ids-form-selection-group class="ids-pt-4" inline>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="true"
              name="additionalInformation_isUnderAge"
              formControlName="additionalInformation_isUnderAge"
              (click)="assetChange(true)"
              idsRadioButton
            />
            <label>sim</label>
          </ids-form-selection>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              [value]="false"
              name="additionalInformation_isUnderAge"
              formControlName="additionalInformation_isUnderAge"
              (click)="assetChange(false)"
              idsRadioButton
            />
            <label>não</label>
          </ids-form-selection>
        </ids-form-selection-group>
      </section>

      <section class="ids-col-6" *ngIf="isAssets()">
        <p class="ids-col-6">especifique a situação</p>
        <ids-form-field class="ids-col-4" [errorMessage]="getErrorMandatory('espólio interdito')">
          <ids-select formControlName="additionalInformation_situation" required>
            <ids-option

              *ngFor="let option of listaEspolio"
              [value]="option.optValue"
            >
              {{ option.optLabel }}
            </ids-option>
          </ids-select>
        </ids-form-field>
      </section>


    </section>
  </form>
</section>
